export const ROUTES_HOME = "home";
export const ROUTES_HELP = "help";
export const ROUTES_ABOUT = "about";

export const ROUTES_IMPRINT = "imprint";

export const SNACKBAR_DEFAULT_TIMEOUT = 5000;

export const enum STATUS_INDICATORS {
  SUCCESS = "success",
  INFO = "info",
  WARNING = "warning",
  ERROR = "error",
}
